// extracted by mini-css-extract-plugin
export default {"warningNotice":"WarningNotice_warningNotice__TUSaL"};